'use client';

import { toast, usePendingFavouriteReplay } from '@shared/components';
import { useTranslations } from 'next-intl';

function PendingFavouriteReplayHandler() {
  const t = useTranslations('casino.favourite');

  usePendingFavouriteReplay({
    onSuccess: ({ name, favouritesRoute }) => {
      toast(t('added', { name }), { type: 'info', action: { label: t('show'), href: favouritesRoute } });
    },
    onError: ({ name }) => {
      toast(t('error', { name }), { type: 'error' });
    },
  });

  return null;
}

export { PendingFavouriteReplayHandler };
